import styled from 'styled-components'
import Colors from '../../../../themes/Colors'

const UploadAdModalHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 21px;

  .ant-upload.ant-upload-drag {
    border-radius: 8px;
  }

  .dragger-content {
    padding: 16px 0;

    .upload-hint {
      font-size: 12px;
      color: ${Colors.textMuted};
      margin-top: 4px;
    }
  }

  /* Selected-files list (multi-file selection): visible + removable. */
  .selected-files {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .selected-files-head {
      font-size: 13px;
      font-weight: 500;
      color: ${Colors.coal};
    }

    .selected-files-list {
      display: flex;
      flex-direction: column;
      gap: 6px;
      max-height: 220px;
      overflow-y: auto;
    }

    .selected-file {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 10px;
      border: 1px solid ${Colors.border};
      border-radius: 6px;

      .file-icon {
        color: ${Colors.primaryAccent};
        flex-shrink: 0;
      }

      .file-name {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: ${Colors.textStrong};
      }

      .file-size {
        flex-shrink: 0;
        font-size: 12px;
        color: ${Colors.textMuted};
      }

      .file-remove {
        flex-shrink: 0;
        cursor: pointer;
        color: ${Colors.textMuted};

        &:hover {
          color: ${Colors.red};
        }
      }
    }
  }

  /* The picked preview, shown inside the dropzone in place of the prompt. */
  .preview-media {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 12px 0;

    .preview-remove {
      position: absolute;
      top: 0;
      right: 8px;
      font-size: 16px;
      cursor: pointer;
      color: ${Colors.textMuted};

      &:hover {
        color: ${Colors.red};
      }
    }

    img,
    video {
      max-width: 100%;
      max-height: 160px;
      border-radius: 6px;
      object-fit: contain;
    }

    .preview-name {
      margin: 0;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: ${Colors.primaryAccent};
      font-weight: 500;
    }
  }

  /* Field scaffolding shared by both upload modes (common file / dynamic ad). */
  .field {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  /* Label and control side by side, each at its natural width — for booleans. */
  .field-inline {
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }

  .field-label {
    margin: 0;
    font-size: 13px;
    font-weight: 500;
    color: ${Colors.coal};

    .field-help {
      margin-left: 6px;
      line-height: 1;
    }
  }

  /* Full modal width, the two options splitting it evenly. Without the flex the
     group stretches but each button keeps its natural inline-block width. */
  .mode-radio {
    margin-bottom: 4px;
    width: 100%;
    display: flex;

    .ant-radio-button-wrapper {
      flex: 1;
      text-align: center;
    }
  }

  /* Whitelist of external URLs: a removable row per entry. */
  .url-row {
    display: flex;
    align-items: center;
    gap: 8px;

    .url-remove {
      flex-shrink: 0;
      cursor: pointer;
      color: ${Colors.textMuted};

      &:hover {
        color: ${Colors.red};
      }
    }
  }

  .upload-breadcrumb {
    font-size: 13px;
    padding: 8px 12px;
    background: ${Colors.background};
    border-radius: 6px;

    /* Collapsed-middle marker: informational, reveals hidden folders on hover. */
    .upload-bc-ellipsis {
      letter-spacing: 1px;
    }
  }
`

export default UploadAdModalHolder
